import { render } from "./homeSlide.vue?vue&type=template&id=2cfec94c&scoped=true"
import script from "./homeSlide.vue?vue&type=script&lang=js"
export * from "./homeSlide.vue?vue&type=script&lang=js"

import "./homeSlide.vue?vue&type=style&index=0&id=2cfec94c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfec94c"]])

export default __exports__